const StringConstants = {
  inputName: 'inputName',
  EmptyString: '',
  toList: 'toList',
  fromList: 'fromList',
  From: 'From',
  To: 'To',
  KP: 'KP',
  RP: 'RP',
  CNFRM: 'CNFRM',
  amt: 'amt',
  when: 'when',
  groupFrom_: 'groupFrom_',
  credit_card: 'credit_card',
  savings: 'savings',
  Nooftimes: 'Nooftimes',
  Pickadate: 'Pickadate',
  setSelOften: 'setSelOften',
  isRepeat: 'isRepeat',
  stop: 'stop',
  dtStart: 'dtStart',
  end: 'end',
  whenicancel: 'whenicancel',
  dtWhen: 'dtWhen',
  reference: 'reference',
  Today: 'Today',
  Days: 'Days',
  current: 'current',
  available: 'available',
  tot: 'tot',
  chooseDate: 'Choose a date',
  Tomorrow: 'Tomorrow',
  mpWhen: 'when',
  mpAmount: 'amount',
  mpFrom: 'from',
  mpTo: 'to',
  mpEdit: 'edit',
  DDPayment: 'DD',
  SOPayment: 'SO',
  whenCancelText: 'When I Cancel',
  singlePayment: 'SinglePayment',
  stopitwhenText: 'stopitwhenText',
  oftenText: 'oftenText',
  SOText: 'Standing order',
  DDText: 'Direct Debit',
  noOfTimesLimit: 300,
  active: 'active',
  weekly: 'weekly',
  singlePayType: 'Single payment',
  DirectDebit: 'Direct Debit',
  all: 'all',
  payment: 'Payment',
  transfer: 'Transfer',
  ddText: 'dd',
  oneMonthly: '1 monthly',
  DELETE_PAYEE: 'DELETE_PAYEE',
  DELETE_PAYMENT: 'DELETE_PAYMENT',
  EDIT_PARTIAL: 'EDIT_PARTIAL',
  unallocated: 'unallocated',
  weeklyUpper: 'WEEKLY',
  monthly: 'monthly',
  transferUpper: 'TRANSFER',
  paymentUpper: 'PAYMENT',
  chooseValue: 'ChooseaValue',
  Type: 'type',
  currencySymbol: '£',
  maxRow: 200,
  referenceMaxLength: 18,
  repeatClicked: 'repeatClicked',
  oneOffClicked: 'oneOffClicked',
  pleaseSelect: 'Please select..',
  payeeTaskUrl: 'WEB-MANAGE-PAYEE',
  interval: 'interval',
  cleared: 'cleared',
  availableOverdraft: 'available_overdraft',
  debitCard: 'debitCard',
  mTrack: 'mTrack',
  marketPlace: 'marketPlace',
  vulnerableCustomers: 'vulnerableCustomers',
  OWNER_ROLE: 'OWNER',

  // Quick Links
  managePaymentQuickLink_CreditCard: 'Manage your scheduled payments',
  managePaymentQuickLink:
    'Manage your Direct Debits, standing orders and other scheduled payments',
  managePayeeQuickLink: 'Manage who you pay',
  mobileDeviceAccessQuickLink: 'Mobile app access',
  userManagementQuickLink: 'User management',
  paymentStatusQuickLink: 'Payment status and history',
  quickLinkTitle: 'Quick links',
  manageYourPayeeQuickLink: 'Manage your payees',
  givingNoticeQuickLink: 'Giving notice',
  // ThankYou Message:
  futureDateStepHeader: "Your payment's been set up",
  currentDateStepHeader: "Your money's on its way",
  scheduledFooter:
    'Please allow until tomorrow or the next working day for it to appear',
  // Manage Payment Constants
  managePaymentHeader: 'Your scheduled payments',
  managePaymentSubheader:
    'Manage your scheduled payments including Direct Debits, standing orders and other payments you’ve set up to be made in the future.',
  aboutDDSO:
    'What’s the difference between a Direct Debit and a standing order?',
  toolTipMessageDD:
    'If you want to make changes to a Direct Debit, you’ll have to get in touch with the company you’re paying to make them for you. You can cancel a Direct Debit on your own at any time but remember to let the company know so they don’t try to take money out your account.',
  toolTipMessageComplexSO:
    'This payment can’t be edited online. Need to make changes to it? Give the team at B a call or pop into your local branch.',
  cancelDDInfo:
    'You’re about to cancel the following Direct Debit. Before you do this, it’s recommended that you get in touch with the company you’re currently paying to let them know you’re cancelling it.',
  after4pmMessage:
    'You can cancel this up to 4pm on the business day before it’s due to be paid. If you cancel it after this time, the payment may still be taken.',
  cancelDDHeader: 'Cancel Direct Debit',
  close: 'Close',
  ok: 'OK',
  cancelDDButton: 'Cancel this Direct Debit',
  cancelSOButton: 'Cancel this standing order',
  cancelSinglePayment: 'Cancel this payment',
  cancelledDDSuccessHeader: "Your Direct Debit's been cancelled",
  cancelledSOSuccessHeader: 'Your standing order’s been cancelled',
  cancelledDDSOSuccessBody:
    'It may be tomorrow (or the next working day) before your changes appear.',
  cancelSOSubHeader: 'You’re about to cancel the following standing order.',
  viewPaymentHeader: 'Manage your scheduled payments',
  cancelPayment: 'Cancel payment',
  edit: 'Edit',
  back: 'Back',
  editPaymentHeader: 'Edit payment',
  continue: 'Continue',
  confirmChanges: 'Confirm changes',
  editSuccessHeader: 'Payment edited',
  allDoneMessage: "All done. You're good to go.",
  oneOffPayment: 'One-off payment',
  unAvailable: 'Unavailable',
  noSchedulePayment: "You don't have any scheduled payments.",
  noScheduleFooter: 'Any new scheduled payments you set up will appear here.',
  activeFooter:
    "That's all of them. Any new scheduled payments you set up will appear here.",
  cancelledFooter:
    "That's all of them. Any archived payments will appear here.",
  accountGO: 'Go to your accounts',
  stopPayment: 'Stop payment',
  nextPayment: 'Next payment',
  noOfPayments: 'Number of payments',
  whenICancelIt: 'When I cancel it',
  afterSetNumberOfPayments: 'After a set number of payments',
  onSetDate: 'On a set date',
  standingOrder: 'Standing order',
  noArchiveText: "You don't have any archived payments.",
  INVALID_DATE: 'Invalid date',

  // Alert Validation message
  //  alertSweepValidationMsg: 'Oops. You’ll have to enter an amount here to continue.',
  sweepStaticHelpMsg:
    'There has to be at least £100 between each amount. So if you’ve chosen less than £50, your target must be £150 or more.',
  sweepTargetValidationMsg:
    'Oops. There has to be at least £100 between each amount.',

  // NBA Constants
  ACCTSUMM: 'ACCTSUMM',
  PRODUCTPAGE: 'PRODUCTPAGE',
  // Move Money
  paymentAmountLimit: 999999,
  payeeLimitDesktop: 10,
  // COP
  COP_ACTIVE: 'active',
  COP_INACTIVE: 'inactive',
  ERR1: 'ERR1',
  ERR2: 'ERR2',
  // FOP
  VIEW_MOBILE: 1,
  VIEW_TABLET: 2,
  VIEW_DESKTOP: 3,
  TRANSACTION_INITIAL_VALUE: 0,
  TRANSACTION_LIMIT: 25,
  ALL: 'All accounts',
  ALL_ACCOUNTS: 'All accounts',

  // Kapiti
  KAPITI_PRODUCT_CODE: '1000',

  // web Task Navigator
  WEB_ACCOUNT_DETAILS: 'WEB-ACCOUNT-DETAILS',
  WEB_HOMEPAGE: 'WEB-HOMEPAGE',
  WEB_RENAME_ACCOUNT: 'WEB-RENAME-ACCOUNT',
  WEB_INVALIDTOKENSESSIONTIMEOUT: 'WEB-INVALIDTOKENSESSIONTIMEOUT',
  NAVIGATE_TO_WEBAPPS: 'NAVIGATE-TO-WEBAPPS',
  WEB_EXPORT_TRANSACTION: 'WEB-EXPORT-TRANSACTION',
  WEB_TASK_MOVE_MONEY: 'WEB-OPEN-MOVEMONEY',
  WEB_TASK_PAYMENT_STATUS: 'WEB-MANAGE-PAYMENT-STATUS',
  WEB_BENEFICIARY_SYNC: 'WEB-BENEFICIARY-SYNC',
  WEB_MASTERCARD_ALERTS: 'WEB-OPEN-ALERTS',
  WEB_MANAGE_CARDS: 'WEB-MANAGE-CARD',
};
export const TYPE_IFT = 'IFT';
export const TYPE_CHAPS = 'CHAPS';
export const CONST_GBP_EQUIVALENT = 'GBP_EQUIVALENT';
export const CONST_AMOUNT_UPPERCASE = 'AMOUNT';
export const CONST_INSTRUCTED = 'INSTRUCTED';
export const CONST_EQUIVALENT = 'EQUIVALENT';
export const CONST_BATCH_TYPE_UPLOAD = 'Upload';
export const PRE_BOOKED_TYPE = 'PRE_BOOKED_RATE';

// TODO: combine the usage of these types with the above constants.
export const paymentTypes = {
  TYPE_BACS_DEBIT: 'BDB',
  TYPE_BACS_CREDIT: 'BCR',
  TYPE_IFT: 'IFT',
  TYPE_CHAPS: 'CHAPS',
  TYPE_FPS: 'Faster Payment',
};

/**
 * @todo - DP
 * Provide the link to the agreed documentation - work in progress...
 */
export const TRANSACTION_REFUND_TYPE_ID = '5';
export const TRANSACTION_REFUND_SUB_TYPE_ID = '56';

export const TRANSACTION_CARD_TYPE_ID = '5';
export const TRANSACTION_ATM_TYPE_ID = '3';

export const TRANSACTION_IS_CARD_HOLDER_PRESENT = 'Y';

export const EXPORT_END_DATE_BUMP = 14;
export const COP_MAX_TRY_COUNT = 5;

export default StringConstants;
